import React from 'react';

export interface AvatarConfig {
  backgroundColor?: string;
  textColor: string;
  initials: string;
  customStyle?: React.CSSProperties;
}

export const avatarConfigMap: Record<string, AvatarConfig> = {
  Alex: {
    textColor: 'text-gray-900',
    initials: '',
    customStyle: {
      backgroundColor: '#e5e5f7',
      opacity: 0.8,
      backgroundImage: `linear-gradient(#3a3a3a 1px, transparent 1px), linear-gradient(to right, #3a3a3a 1px, #e5e5f7 1px)`,
      backgroundSize: '8px 8px',
    },
  },
  You: {
    textColor: 'text-gray-900',
    initials: '',
    customStyle: {
      backgroundColor: '#e5e5f7',
      opacity: 0.8,
      backgroundImage: `linear-gradient(135deg, #3a3a3a 25%, transparent 25%), linear-gradient(225deg, #3a3a3a 25%, transparent 25%), linear-gradient(45deg, #3a3a3a 25%, transparent 25%), linear-gradient(315deg, #3a3a3a 25%, #e5e5f7 25%)`,
      backgroundPosition: '10px 0, 10px 0, 0 0, 0 0',
      backgroundSize: '10px 10px',
      backgroundRepeat: 'repeat',
    },
  },
  // Add more senders as needed
};

export function getAvatarConfig(senderName: string): AvatarConfig {
  return (
    avatarConfigMap[senderName] ?? {
      backgroundColor: 'bg-gray-200',
      textColor: 'text-gray-700',
      initials: senderName.charAt(0).toUpperCase(),
    }
  );
}
